export const API_URL = process.env.REACT_APP_BACKEND_URL;

export const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('session_token')}` });

export const fmtWeek = (ws) => {
  const s = new Date(`${ws}T00:00:00`);
  const e = new Date(s);
  e.setDate(s.getDate() + 6);
  const md = { month: 'short', day: 'numeric' };
  const end = e.toLocaleDateString('en-US', s.getMonth() === e.getMonth() ? { day: 'numeric' } : md);
  return `${s.toLocaleDateString('en-US', md)} – ${end}, ${e.getFullYear()}`;
};
